<template>
  <v-container class="align-self-start">
    <div class="d-flex justify-center">
      <div class="">
        <v-text-field v-model="userFilters.search" solo placeholder="Search Movies" v-on:keyup.enter="submitSearch" class="pt-5"></v-text-field>
      </div>
      <div>
        <v-btn
          fab
          dark
          color="primary"
          class="ma-2 ml-6"
          @click="submitSearch()"
        >
          <v-icon>fa fa-search</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          color="primary darken-1"
          class="ma-2 mr-0"
          @click="searchToggle()"
        >
          <v-icon>fa fa-search-plus</v-icon>
        </v-btn>
        <v-dialog v-model="advSearch" persistent max-width="800px">
          <v-card>
            <v-card-title>
              <span class="text-h5">Advanced Search</span>
              <div class="flex-grow-1"></div>
              <v-btn text color="base" @click="searchToggle()">
                <v-icon>fa fa-times</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-container> 
                <v-row dense justify-space-between wrap>
                  <v-col class="d-flex" cols="12" md="4">
                    <v-text-field
                      dark
                      clearable
                      prepend-icon="search"
                      v-model="userFilters.search"
                      label="Search"
                      single-line
                    ></v-text-field>
                  </v-col>
                  <v-col class="d-flex" cols="12" md="4">
                    <v-combobox
                        v-model="userFilters.genres"
                        :items="genres"
                        label="Genres"
                        class="mt-2"
                        multiple
                        chips
                        dense
                      ></v-combobox>
                  </v-col>
                  <v-col class="d-flex" cols="12" md="4">
                    <v-row dense justify-space-between wrap>
                      <v-col class="d-flex" cols="12">
                        <v-combobox
                          v-model="userFilters.movieFormat"
                          :items="formats"
                          label="Disc Format"
                          multiple
                          class="mt-2"
                          chips
                          dense
                        ></v-combobox>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row dense justify-space-between wrap>
                  <v-col class="d-flex" cols="12">
                    <v-row dense justify-space-between wrap>
                      <v-col class="d-flex" cols="12">
                        <!-- Open Date -->
                        <v-row dense>
                          <v-col cols="6">
                            <v-menu
                              ref="release_from"
                              v-model="release_from"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="userFilters.releaseDate.from"
                                  label="Released From"
                                  prepend-icon="event"
                                  v-on="on"
                                  clearable
                                  clear-icon="close"
                                ></v-text-field>
                              </template>
                              <v-date-picker type="month" v-model="userFilters.releaseDate.from">
                                <div class="flex-grow-1"></div>
                                <v-btn text color="base" @click="release_from = false">Cancel</v-btn>
                                <v-btn text color="primary" @click="$refs.release_from.save(date)">OK</v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="6">
                            <v-menu
                              ref="release_to"
                              v-model="release_to"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="userFilters.releaseDate.to"
                                  label="Released To"
                                  prepend-icon="event"
                                  v-on="on"
                                  clearable
                                  clear-icon="close"
                                ></v-text-field>
                              </template>
                              <v-date-picker type="month" v-model="userFilters.releaseDate.to">
                                <div class="flex-grow-1"></div>
                                <v-btn text color="base" @click="release_to = false">Cancel</v-btn>
                                <v-btn text color="primary" @click="$refs.release_to.save(date)">OK</v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn text color="base" @click="resetUserFilters(true)">Reset</v-btn>
              <v-btn text color="primary" @click="searchToggle(); getData()">Search</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>
    <div class="d-flex justify-center mb-2">
      <v-icon x-large dark v-if="loading">fa fa-spinner fa-spin</v-icon>
    </div>
    <div id="movies" v-if="!loading">
      <div class="d-flex justify-center mb-2" v-if="movies.length === 0">
        <v-icon x-large dark color='orange'>fa fa-exclamation-triangle</v-icon> <span class="mx-6 my-2">No Movies Found</span>
      </div>
      <div
        v-for="movie in movies"
        :key="movie.itemTitle"
        @click="moneyshot(movie)"
      >
        <div v-if="!showMoney" class="movie">
          <div class="movieTitle">{{ movie.title || movie.itemTitle }}</div>
          <div class="movieTitleSub"><small v-if="movie.releaseDate">{{ movie.releaseDate.split('-')[0] }}</small><small v-if="!movie.releaseDate">Release Date Unknown</small></div>
          <div class="moviePoster" v-if="movie.posterPath !== null"
            v-bind:style="{ backgroundImage: 'url(https://image.tmdb.org/t/p/w185/' + movie.posterPath + ')' }"
          ></div>
          <div class="moviePosterBlank" v-if="movie.posterPath === null"></div>
        </div>
      </div>
    </div>
    <div
      v-for="movie in movies"
      :key="`moneyshot-${movie.itemTitle}`"
      align="center"
    >
      <v-row v-if="showMoney && movie.itemTitle === thisMovie.itemTitle" class="movieDetail mb-5 d-flex justify-items-left align-stretch elevation-10" v-bind:style="{ backgroundImage: 'url(https://image.tmdb.org/t/p/w1280/' + movie.backdropPath + ')' }">
        <v-col cols="3" class="poster py-6 pl-6" v-if="movie.posterPath">
          <img v-bind:src="`https://image.tmdb.org/t/p/w300/${ movie.posterPath }`" />
        </v-col>
        <v-col cols="7" class="infoBlock pa-6 pr-12">
          <h2>
            {{ movie.title || movie.itemTitle }}
            <v-tooltip
              v-model="show"
              top
              v-if="movie.movieFormat.includes('DVD')"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="white">mdi-disc</v-icon>
                </v-btn>
              </template>
              <span>Available on DVD</span>
            </v-tooltip>
            <v-tooltip
              v-model="show2"
              top
              v-if="movie.movieFormat.includes('BLU')"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary">mdi-disc</v-icon>
                </v-btn>
              </template>
              <span>Available on BluRay</span>
            </v-tooltip>
          </h2>
          <h3 v-if="movie.originalTitle && movie.originalLanguage !== 'en'"><small v-if="movie.originalLanguage">[{{ movie.originalLanguage }}]</small> {{ movie.originalTitle }}</h3>
          <small><i>{{ movie.tagline }}</i></small>
          <p class="mt-6">{{ movie.overview}}</p>
          <div v-if="movie.genres !== null">
            <strong>Genres </strong> {{ movie.genres }}
          </div>
          <div v-if="movie.budget"><strong>Budget</strong> {{ movie.budget.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</div>
          <div v-if="movie.releaseDate"><strong>{{ movie.status || 'Released' }}</strong> {{ movie.releaseDate }}</div>
        </v-col>
        <v-col cols="2">
          <v-btn
            fab
            dark
            small
            color="primary"
            class="ma-2 ml-6 elevation-6 float-right"
            @click="regular()"
          >
            <v-icon>fa fa-times</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <div class="text-center">
      <v-pagination
        v-model="page"
        :length="totalCount"
        :total-visible="ipp"
        @input="handlePageChange"
        prev-icon="arrow_left"
        next-icon="arrow_right"
        circle
      ></v-pagination>
    </div>
  </v-container>
  
</template>

<script>
import { RepositoryFactory } from '@/api/repositoryFactory';
import { mdiDisc } from '@mdi/js'
const videoRepo = RepositoryFactory.get('video');

export default {
  name: 'MovieList',
  props: {
  },
  data: () => ({
    totalCount: 0,
    ipp: 12, /// items per page
    page: 1,
    fab: false,
    search: '',
    movies: [],
    genres: ['Action', 'Adventure', 'Animation', 'Comedy', 'Crime', 'Documentary', 'Drama', 'Family', 'Fantasy', 'History', 'Horror', 'Music', 'Mystery', 'Romance', 'Science Fiction','TV Movie', 'Thriller', 'War', 'Western'],
    formats: ['DVD', 'BLU'],
    loading: true,
    advSearch: false,
    release_from: false,
    release_to: false,
    showMoney: false,
    show: false,
    show2: false,
    thisMovie: {},
    userFilters: {
      search: '',
      movieFormat: '',
      genres: [],
      releaseDate: {
        from: '',
        to: '',
      },
    }
  }),
  methods: {
    resetUserFilters() {
      this.showMoney = false;
      this.userFilters = {
        search: '',
        movieFormat: '',
        genres: [],
        releaseDate: {
          from: '',
          to: '',
        },
      }
    },
    searchToggle() {
      this.showMoney = false;
      this.advSearch = !this.advSearch
    },
    submitSearch() {
      this.showMoney = false;
      this.page = 1;
      this.searchQueryIsDirty = true
      this.getData();
    },
    moneyshot(movie) {
      console.log(movie)
      this.showMoney = true;
      this.thisMovie = movie;
    },
    regular(movie) {
      this.showMoney = false;
    },
    getData(options) {
      this.showMoney = false;
      this.loading = true;
      const req = { 
        params: {
          page: this.page,
          limit: this.ipp,
          totalCount: true,
          order: '^itemTitle'
        }
      }
      if(this.userFilters.search) {
        req.params.itemTitle__contains = this.userFilters.search
      }
      if(this.userFilters.movieFormat.length > 0) {
        if(this.userFilters.movieFormat.length === 1) {
          req.params.movieFormat__contains = this.userFilters.movieFormat[0]
        } else {
          let str = ""
          this.userFilters.movieFormat.forEach((i, index) => {
            if(index === 0) {
              str = `movieFormat__contains:${i}`
            } else {
              str += `|movieFormat__contains:${i}`
            }
          })
          req.params.$or = str
        }
      }
      if(this.userFilters.genres.length > 0) {
        if(this.userFilters.genres.length === 1) {
          req.params.genres__contains = this.userFilters.genres[0]
        } else {
          let str = ""
          this.userFilters.genres.forEach((i, index) => {
            if(index === 0) {
              str = `genres__contains:${i}`
            } else {
              str += `|genres__contains:${i}`
            }
          })
          req.params.$or = str
        }
      }
      if(this.userFilters.releaseDate.from || this.userFilters.releaseDate.to) {
        let to = this.userFilters.releaseDate.to
        let from = this.userFilters.releaseDate.from

        if(from !== '' && to === '') {
          var d = new Date();
          var n = d.toISOString().substring(0, 8);
          to = n
          from = from.substring(0, 8)
        }
        if(to !== '' && from === '') {
          from = "190001"
          to = to.substring(0, 8)
        }
        req.params.releaseDateRange__between = `${from.replaceAll('-', '')},${to.replaceAll('-', '')}`
      }

      Object.assign(req.params, options || {});
      return videoRepo.getMovies(req)
        .then(resp => {
          this.movies = resp.data.data;
          this.totalCount = Math.ceil(resp.data.totalCount / this.ipp)
        })
        .finally(() => {
          this.loading = false;
        })
    },
    handlePageChange(value) {
      this.showMoney = false;
      this.page = value;
      this.getData();
    },
  },
  mounted() {
    this.getData({ page: 1, limit: this.ipp, totalCount: true});
  }
};
</script>
<style>
  .v-speed-dial--direction-bottom .v-speed-dial__list {
    top: 55px !important;
  }
  #movies {
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
  }
  .movie {
    max-width: 185px;
    margin: 10px 10px 20px 10px;
    cursor: pointer;
  }
  .moviePoster, .moviePosterBlank {
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    width: 185px;
    min-height: 278px;
    padding: 0px;
  }
  .moviePosterBlank {
    background-color: #333;
  }
  .movieTitle {
    font-size: .75em;
    text-align: center;
    letter-spacing: 1px;
    width: 185px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 0px;
    font-weight: bolder;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
  }
  .movieTitleSub {
    font-size: .8em;
    text-align: center;
    letter-spacing: 1px;
    width: 185px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 15px;
    color: #ccc;
    font-weight: bolder;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
  }
  .movieDetail {
    width: 100%;
    height: 100%;
    min-height: calc(100vh - 370px);
    max-height: 720px;
    max-width: 1280px;
    background-position: top right;
    background-size: contain;
    background-color: black;
    overflow-y: auto;
    overflow-x: hidden;
    text-align: left;
  }
  .movieDetail .infoBlock {
    width: 100%;
    background: linear-gradient(
      to right,
      black, transparent
    );
  }
  .movieDetail .poster {
    background-color: black;
  }
  .movieDetail .poster img {
    width: 100%;
    max-width: 300px;
  }
</style>
